export default "__VITE_ASSET__0a960b76__"